import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { Button } from '@salesforce/design-system-react';
import { AttributeMappingRow } from '../';

import './AttributeMappingEditor.scss';

class AttributeMappingEditor extends Component {
  dropdownOptions(type) {
    const { mappingRules = {}, [`${type}Keys`]: keys } = this.props;

    if (!Object.keys(mappingRules).length) {
      return keys;
    }

    const mappedKeys = this.getMappedKeys(type, mappingRules);

    return keys ? keys.filter(key => mappedKeys.indexOf(key) < 0) : [];
  }

  getMappedKeys(type, rules) {
    switch (type) {
      case 'asset':
        return Object.keys(rules);
      case 'profile':
        return Object.values(rules).map(value => value.consumerKey);
      default:
        return [];
    }
  }

  rows(assetsList, profilesList) {
    const mappingRules = Object.entries(this.props.mappingRules || {});
    const showFallbackColumn = mappingRules.some(
      entry => entry[1]?.applyToFallback
    );

    if (this.props.showNewMappingRow) {
      mappingRules.push([undefined, undefined]);
    }

    return mappingRules.map(([key, rule], index) => {
      const profileKey = rule?.consumerKey || null;
      const mustMatch = rule?.mustMatch || false;
      const applyToFallback = rule?.applyToFallback || false;

      return (
        <AttributeMappingRow
          id={`rule${index}-${key}`}
          key={`rule${index}-${key}`}
          actions={this.props.actions}
          assetKey={key}
          assetKeys={assetsList}
          profileKey={profileKey}
          profileKeys={profilesList}
          mustMatch={mustMatch}
          applyToFallback={applyToFallback}
          showFallbackColumn={showFallbackColumn}
          mappingRules={this.props.mappingRules}
          onRuleChange={(update, replaceAll) =>
            this.props.onRuleChange(update, replaceAll)
          }
          onDeleteRule={() => this.props.onDeleteRule(key)}
        />
      );
    });
  }

  render() {
    const { formatMessage } = this.props.intl;
    const assetsList = this.dropdownOptions('asset');
    const profilesList = this.dropdownOptions('profile');

    return (
      <section className="attribute-mapping-editor">
        <div className="mapping-rule-rows">
          {this.rows(assetsList, profilesList)}
        </div>

        {!assetsList.length || !profilesList.length ? null : (
          <Button
            className="add-mapping-button"
            label={formatMessage({
              id: 'components.ecs.rules.mapping.addMapping'
            })}
            iconCategory="utility"
            iconName="add"
            iconPosition="left"
            onClick={this.props.onAddNewMapping}
            disabled={!this.props.canAddMapping}
          />
        )}
      </section>
    );
  }
}

AttributeMappingEditor.propTypes = {
  actions: PropTypes.object,
  assetKeys: PropTypes.array,
  profileKeys: PropTypes.array,
  mappingRules: PropTypes.object,
  onRuleChange: PropTypes.func.isRequired,
  onAddNewMapping: PropTypes.func.isRequired,
  onDeleteRule: PropTypes.func.isRequired,
  showNewMappingRow: PropTypes.bool,
  canAddMapping: PropTypes.bool,
  intl: intlShape.isRequired
};

export default injectIntl(AttributeMappingEditor);
